// extracted by mini-css-extract-plugin
module.exports = {"Paper":"Paper_Paper__4DtnW"};